import { gql } from "@apollo/client";

export const SEND_SMS = gql`
  mutation sendSms($input: SendSmsInput!) {
    sendSms(input: $input) {
      status
      messageSid
      to
      from
      body
      error
    }
  }
`;
